import { DebouncedObservable } from '@inter-ikea-betrakta/viewer/dist/modules/DebouncedObservable/DebouncedObservable';
import { ComponentIds } from '@inter-ikea-core/core';
import { SystemBase2 } from '@inter-ikea-core/core-toolbox';
import { getIpexViewer } from '@inter-ikea-core/ipex-betrakta-core-adapter';
import { HideOccludingObjectsComponentIds } from './types';
import { FadeAnimationComponent } from './FadeAnimationComponent';
// Time after update we consider camera stopped. Longer than CAMERA_UPDATE_TIME
// to be sure stop is fired after update
const CAMERA_UPDATE_STOP_TIME = 150;
/**
 * The system handles the animation of the material applied to the objects that
 * fade away when hidden.
 */
export class FadeAnimationSystem extends SystemBase2 {
    get viewer() {
        return getIpexViewer(this.coreServices.sceneManager);
    }
    constructor(coreServices) {
        super(ComponentIds.WORLD_SPACE_DRAG_EVENT_COMPONENT_ID, ComponentIds.SELECTED_COMPONENT_ID);
        this.coreServices = coreServices;
        this.id = 'FadeAnimationSystem';
        this.systemsAfterMe = [];
        this.systemsBeforeMe = [];
        this.doingChangesOnComponent = [];
        this.onCameraUpdatedDebouncedObserver = null;
    }
    enable() {
        super.enable();
        const onCameraStart = () => {
            this.coreServices.sceneManager.scene.addComponent(new FadeAnimationComponent(false));
        };
        const onCameraStop = () => {
            this.coreServices.sceneManager.scene.addComponent(new FadeAnimationComponent(true));
        };
        if (this.viewer) {
            const observable = this.viewer.get_camera_updated_observable();
            this.onCameraUpdatedDebouncedObserver = new DebouncedObservable(this.viewer, observable, {
                frames_to_start: 1,
                frames_to_end: 2,
                debounce_time: CAMERA_UPDATE_STOP_TIME
            });
            this.onCameraUpdatedDebouncedObserver.on_start.add(onCameraStart);
            this.onCameraUpdatedDebouncedObserver.on_end.add(onCameraStop);
        }
    }
    disable() {
        this.onCameraUpdatedDebouncedObserver?.dispose();
        this.onCameraUpdatedDebouncedObserver = null;
        super.disable();
    }
    onUpdateComponent(_entity, _oldComponent, _newComponent) {
        this.coreServices.sceneManager.scene.addComponent(new FadeAnimationComponent(false));
    }
    onRemoveComponent(_entity, _oldComponent) {
        this.coreServices.sceneManager.scene.addComponent(new FadeAnimationComponent(true));
    }
    onAddComponent2(entity, _oldComponent) {
        this.stopFadeAnimation(entity);
    }
    onRemoveComponent2(entity, _oldComponent) {
        this.startFadeAnimation(entity);
    }
    startFadeAnimation(entity) {
        if (entity.hasComponent(HideOccludingObjectsComponentIds.FADE_MATERIAL_COMPONENT_ID) &&
            !entity.hasComponent(ComponentIds.SELECTED_COMPONENT_ID)) {
            this.coreServices.sceneManager.scene.addComponent(new FadeAnimationComponent(true));
        }
    }
    stopFadeAnimation(entity) {
        if (entity.hasComponent(HideOccludingObjectsComponentIds.FADE_MATERIAL_COMPONENT_ID)) {
            this.coreServices.sceneManager.scene.addComponent(new FadeAnimationComponent(false));
        }
    }
}
//# sourceMappingURL=FadeAnimationSystem.js.map